__turbopack_context__.v({
  "arrow1": "HowItWorks-module__W8Q5bq__arrow1",
  "arrow2": "HowItWorks-module__W8Q5bq__arrow2",
  "cageBalls": "HowItWorks-module__W8Q5bq__cageBalls",
  "headingContainer": "HowItWorks-module__W8Q5bq__headingContainer",
  "headingText": "HowItWorks-module__W8Q5bq__headingText",
  "howItWorks": "HowItWorks-module__W8Q5bq__howItWorks",
  "innerStep": "HowItWorks-module__W8Q5bq__innerStep",
  "introHeading": "HowItWorks-module__W8Q5bq__introHeading",
  "prizesPopUp": "HowItWorks-module__W8Q5bq__prizesPopUp",
  "step": "HowItWorks-module__W8Q5bq__step",
  "step1": "HowItWorks-module__W8Q5bq__step1",
  "step2": "HowItWorks-module__W8Q5bq__step2",
  "step3": "HowItWorks-module__W8Q5bq__step3",
  "stepDescription": "HowItWorks-module__W8Q5bq__stepDescription",
  "stepTitle": "HowItWorks-module__W8Q5bq__stepTitle",
  "stepsWrapper": "HowItWorks-module__W8Q5bq__stepsWrapper",
});
